<template>
    <!-- <div class="layout-topbar">
        <Link href="/" class="layout-topbar-logo">
            VectorVS
        </Link>
        <button class="p-link layout-menu-button layout-topbar-button" @click="onMenuToggle">
            <i class="pi pi-bars"></i>
        </button>

        <button class="p-link layout-topbar-menu-button layout-topbar-button"
                :class="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein',
			leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true}">
            <i class="pi pi-ellipsis-v"></i>
        </button>
        <ul class="layout-topbar-menu hidden lg:flex origin-top" v-if="false">
            <li>
                <button class="p-link layout-topbar-button">
                    <i class="pi pi-calendar"></i>
                    <span>Events</span>
                </button>
            </li>
            <li>
                <Button
                    class="p-button-link  p-link layout-topbar-button"
                    @click="goToSettings"
                >
                    <i class="pi pi-cog"></i>
                    <span>Settings</span>
                </Button>
            </li>
            <li>
                <Button
                    class="p-button-link p-link layout-topbar-button"
                >
                    <i class="pi pi-user"></i>
                    <span>Profile</span>
                </Button>
            </li>
        </ul>
    </div> -->

    <div class="admin_header">
        <div class="admin_header_container">
            <div class="header_container">
                <a href="https://vector-vs.com" class="logo">
                    <img src="/img/logo.svg" class="logo_img">
                </a>
                <button class="p-link layout-menu-button layout-topbar-button" @click="onMenuToggle">
                    <i class="pi pi-bars"></i>
                </button>
            </div>
            <div class="header_container">
                <a class="header_user" v-on:click="doToggle()">
                    {{ $page.props.user.name  }}
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 4C11.93 4 13.5 5.57 13.5 7.5C13.5 9.43 11.93 11 10 11C8.07 11 6.5 9.43 6.5 7.5C6.5 5.57 8.07 4 10 4ZM10 18C7.97 18 5.57 17.18 3.86 15.12C5.55 13.8 7.68 13 10 13C12.32 13 14.45 13.8 16.14 15.12C14.43 17.18 12.03 18 10 18Z" fill="white"/>
                    </svg>
                </a>
                <div class="user_modal" v-if="toggle">
                    <div class="user_modal_container">
                        <div class="modal_row">
                            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13 0.5C6.1 0.5 0.5 6.1 0.5 13C0.5 19.9 6.1 25.5 13 25.5C19.9 25.5 25.5 19.9 25.5 13C25.5 6.1 19.9 0.5 13 0.5ZM13 5.5C15.4125 5.5 17.375 7.4625 17.375 9.875C17.375 12.2875 15.4125 14.25 13 14.25C10.5875 14.25 8.625 12.2875 8.625 9.875C8.625 7.4625 10.5875 5.5 13 5.5ZM13 23C10.4625 23 7.4625 21.975 5.325 19.4C7.4375 17.75 10.1 16.75 13 16.75C15.9 16.75 18.5625 17.75 20.675 19.4C18.5375 21.975 15.5375 23 13 23Z" fill="#356EEF"/>
                            </svg>
                            <div class="info_group">
                                <p class="user_name">{{ $page.props.user.name }} {{ $page.props.user.last_name }}</p>
                                <p class="user_email">{{ $page.props.user.email  }}</p>
                            </div>
                        </div>
                    </div>
                    <a v-on:click="logout()" class="logout_btn">Вихід</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Link} from '@inertiajs/inertia-vue3';
import Button from "primevue/button";
import axios from "axios";
import Vue from 'vue';

export default {
    components: {
        Link,
        Button
    },
    data() {
        return {
            toggle: false,
        }
    },
    mounted() {
        window.addEventListener('click', this.outsideClick);
    },
    destroyed() {
        window.removeEventListener('click', this.outsideClick);
    },
    methods: {
        outsideClick(event) {
            let elClass = event.target.getAttribute("class")
            if (
                elClass &&
                elClass !== 'header_user'
            ) {
                this.toggle = false
            }
        },
        onMenuToggle(event) {
            this.$emit('menu-toggle', event);
        },
        onTopbarMenuToggle(event) {
            this.$emit('topbar-menu-toggle', event);
        },
        goToSettings(){
            this.$inertia.get(this.route('profile.show'));
        },
        doToggle() {
            this.toggle = !this.toggle;
        },
        logout() {
            this.$inertia.post(this.route('logout'));
        }
    },
}
</script>

<style scoped>
.admin_header {
    width: 100%;
    height: 74px;
    background: #356EEF;
    padding-left: 72px;
    padding-right: 72px;
    display: flex;
    align-items: center;
    position: fixed;
    z-index: 5;
}
.header_container {
    display: flex;
    align-items: center;
    gap: 70px;
    position: relative;
}
.p-link i {
    color: #ffff;
    font-size: 25px;
}
.admin_header_container {
    font-size: 16px;
    /* max-width: 1296px; */
    display: flex;
    justify-content: space-between;
    width: 100%;
}
.header_user {
    display: flex;
    align-items: center;
    gap: 12px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #FFFFFF; 
    text-decoration: none;
    cursor: pointer;
}
.user_modal {
    position: absolute;
    top: 45px;
    right: -25px;
    z-index: 10;
    height: 146px;
    width: 269px;
    background: #FFFFFF;
    box-shadow: 0px 5px 30px rgb(53 110 239 / 18%);
    border-radius: 4px;
}
.user_modal_container {
    padding: 22px 18px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.modal_row {
    display: flex;
    align-items: flex-start;
    gap: 12px;
}
.user_name {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    margin: 0;
}
.user_email {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #767676;
}
.logout_btn {
    padding: 10px 18px;
    background: rgba(200, 228, 255, 0.5);
    display: flex;
    cursor: pointer;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    text-decoration: none;
}
.layout-topbar-button:focus {
    box-shadow: none!important;
}
@media (max-width: 780px) {
    .admin_header {
        padding-left: 20px;
        padding-right: 20px;
    }
    .header_container {
        gap: 9px;
    }
    .header_user {
        font-size: 12px;
        gap: 12px;
    }
    .user_modal {
        top: 45px;
        right: 13px;
    }
}
</style>
